import leasingProfiles from "./LeasingProfilesReducer";

export default leasingProfiles;